import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from 'src/app/modules/local-storage/local-storage.module';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'brover-order-history',
    templateUrl: './oci.component.html',
    standalone: false
})
export class OciComponent implements OnInit {
  
  ngOnInit(): void {
      console.log('init oci');
  }

  constructor(  private settingsService: AuthService, private activatedRoute: ActivatedRoute,     private localStorageService: LocalStorageService,  private router: Router
) {
        let param1 = this.activatedRoute.snapshot.queryParams["key"];
        let param2 = this.activatedRoute.snapshot.queryParams["callback"];
        this.localStorageService.set('access-token', `bearer ${param1}`);
        this.localStorageService.set('oci-callback-url', param2);
    
        this.localStorageService.set('refresh-token', param2);
                  console.log(this.settingsService.isAuthenticated())

        console.log(this.localStorageService.get('access-token'));


         this.settingsService.loadUser().then(() => {
              this.localStorageService.remove('state');
              this.localStorageService.remove('code_challenge');
              this.router.navigate(['/'], { queryParams: {}});
            });
    // this.router.navigate(['/dashboard/place-order'], { queryParams: {}});
                    


  }
}
